<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">No de Declaraciones</h4>
        <div class="row">

          <div v-if="rol!=4" class="col-md-4">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label>Desde</label><br>
            <el-date-picker name="fecha_inicio" v-model="model.fecha_inicio" format="dd-MM-yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
          <div class="col-md-4">
            <label>Hasta</label><br>
            <el-date-picker name="fecha_fin" v-model="model.fecha_fin" format="dd-MM-yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
          <div class="col-md-12">
            <label></label><br>
            <div class="row">
              <div class="col-sm-12">
                <button @click="getDeclaracionesR" class="btn btn-fill btn-success " style="text-align:left">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <br>
          <div class="row">
            <div class="col-sm-6">

              <export-excel class="btn btn-wd btn-success" :data="list_cumplimiento" :meta="meta" :fields="no_declaraciones" worksheet="Resumén declaraciones" name="Resumén declaraciones.xls">
                <span class="btn-label">
                  <i class="fa fa-file-excel"></i>
                </span>
                Descargar Reporte
              </export-excel>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
              <b-form-group>
                <b-input-group>
                  <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <v-data-table :headers="headers2" :items="list_cumplimiento" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">
                    <b-button @click.prevent="descargar(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Descargar Declaración'">
                      <i class="ti-download"></i></b-button>
                  </div>
                </template>
                <!-- <template v-slot:item.titular_id="{ item }">
                  <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
                </template> -->
                <template v-slot:item.t_inicial="{ item }">
                  <v-progress-circular :rotate="360" :size="70" :width="5" :value="item.l_inicial" color="teal">
                    <strong>{{ item.r_iniciales }}</strong>
                  </v-progress-circular>
                </template>
                <template v-slot:item.t_anual="{ item }">
                  <v-progress-circular :rotate="360" :size="70" :width="5" :value="item.l_anual" color="teal">
                    <strong>{{ item.r_anuales }}</strong>
                  </v-progress-circular>
                </template>
                <template v-slot:item.t_final="{ item }">
                  <v-progress-circular :rotate="360" :size="70" :width="5" :value="item.l_final" color="teal">
                    <strong>{{ item.r_finales }}</strong>
                  </v-progress-circular>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fin -->

  </div>
</template>
<script>
  import Vue from 'vue'
  import {
    Table,
    TableColumn,
    Select,
    Option,
    DatePicker
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        model: {
          tipo_declaracion: '',
          dependencia_id: '',
          dependencia_id1: '',
          periodo: ''
        },
        rol: '',
        filter: null,
        currentPage: 1,
        dependencias: {},
        perPage: 50,
        periodos: [],
        rows: null,
        tiposDeclaracion: [],
        list_cumplimiento: [],

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        meta: [
          [{
            'key': 'charset',
            'value': 'utf-8'
          }]
        ],
        faltantes_campos: {
          'ID': 'id',
          'RFC': 'rfc',
          'NOMBRE': 'nombres',
          'DEPENDENCIA': 'entidad',
          'CORREO LABORAL': 'correo',
        },
        no_declaraciones: {
          'Dependencia': 'dependencia',
          'Total Iniciales': 'r_iniciales',
          'Total Anuales': 'r_anuales',
          'Total Finales': 'r_finales'
        },
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Id',
          value: 'id',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Nombre',
          value: 'nombres',
          align: '',
        }, {
          text: 'Dependencia',
          value: 'entidad',
          align: '',
        }, {
          text: 'Correo Laboral',
          value: 'correo',
          align: '',
        }, ],
        headers2: [{
            text: 'Dependencia',
            align: '',
            value: 'dependencia',
          }, {
            text: 'Total Iniciales',
            value: 't_inicial',
            align: 'center',
          }, {
            text: 'Total Anuales',
            value: 't_anual',
            align: 'center',
          },
          {
            text: 'Total Finales',
            value: 't_final',
            align: 'center',
          },
        ],
        headers3: [{
          text: 'Dependencia',
          align: '',
          value: 'ente',
        }, {
          text: 'Total declaraciones',
          value: 'total',
          align: 'center',
        }, {
          text: 'Tipo',
          value: 'tipo',
          align: 'center',
        }],
        propsToSearch: ['rfc', 'nombres'],
        tableColumns: [{
            prop: 'id',
            label: 'Dec',
            minWidth: 150,
            vif: false
          },
          {
            prop: 'rfc',
            label: 'RFC',
            minWidth: 150,
            vif: true
          },
          {
            prop: 'nombres',
            label: 'Nombre',
            minWidth: 100,
            vif: true
          }
        ]
      }
    },
    computed: {
      pagedData() {
        return this.list_cumplimiento.slice(this.from, this.to)
      },
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.list_cumplimiento.length
          return this.pagedData
        }
        let result = this.list_cumplimiento
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_cumplimiento.length);
        this.rows = this.list_cumplimiento.length;

        return this.list_cumplimiento.length;
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      checkPermissions() {
        let permiso = [1];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      },

      getTipoDeclaracion() {
        var v = this;
        this.$http.get("tiposDeclaracion").then(
          response => {
            this.tiposDeclaracion = response.data.tipoDeclaracion;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getDeclaracionesR() {
        this.model.estatus = 0;
        this.model.tipo_declaracion = 4;
        this.model.periodo = new Date().getFullYear();
        //console.log(this.model, new Date().getFullYear());

        this.$http.post("repndeclaraciones", this.model).then(
          response => {
            this.list_cumplimiento = [];
            response.data.forEach((value, key) => {
              var obj = {
                dependencia: value.dependencia ? value.dependencia : '',
                cumplidos: value.cumplidos ? value.cumplidos : 0,
                obligados_iniciales: value.obligados_iniciales ? value.obligados_iniciales : 0,
                obligados_anuales: value.obligados_anuales ? value.obligados_anuales : 0,
                obligados_finales: value.obligados_finales ? value.obligados_finales : 0,
                r_iniciales: value.r_iniciales ? value.r_iniciales : 0,
                r_anuales: value.r_anuales ? value.r_anuales : 0,
                r_finales: value.r_finales ? value.r_finales : 0,
                l_inicial: 0,
                l_anual: 0,
                l_final: 0,
              };

              if (value.obligados_iniciales > 0 && value.r_iniciales > 0) {
                obj.l_inicial = value.r_iniciales * 100 / value.obligados_iniciales;
              }
              if (value.obligados_anuales > 0 && value.r_anuales > 0) {
                obj.l_anual = value.r_anuales * 100 / value.obligados_anuales;
              }
              if (value.obligados_finales > 0 && value.r_finales > 0) {
                obj.l_final = value.r_finales * 100 / value.obligados_finales;
              }

              this.list_cumplimiento.push(obj);

            });
            // console.log(response.data);
            /*
            dependencia	"Centro de Evaluación y Control de Confianza del Estado de Guanajuato"
            r_iniciales	0
            r_anuales	0
            r_finales	0

            obligados_anuales: 33
            obligados_finales: 1
            obligados_iniciales: 2
            r_anuales: 32
            r_finales: 1
            r_iniciales: 2
            */

            /*  */
          },
          error => {
            this.StepError(error);
          }
        );
      },
      /*
       getDeclaracionesR() {
        this.$http.post("rdeclaraciones2", this.model).then(
          response => {
            this.list_cumplimiento = [];
            response.data.declarantes.forEach((value, key) => {
              this.list_cumplimiento.push({
                'ente': value.ente,
                'total': value.total,
                'tipo': value.tipo
              });
              console.log(this.list_cumplimiento);
            });
            //this.filtro_usuarios1 = this.list_cumplimiento;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getDeclaracionesPorFecha() {
        this.$http.post("rdeclaraciones", this.model).then(
          response => {
            this.list_cumplimiento1 = [];
            response.data.declarantes.forEach((value, key) => {
              this.list_cumplimiento1.push({
                'id': value.decid,
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'entidad': value.ente,
                'correo': value.correo,
                'tipoDec': value.tipoDec
              });
              console.log(this.list_cumplimiento1);
            });
            this.filtro_usuarios = this.list_cumplimiento1;
          },
          error => {
            this.StepError(error);
          }
        );


      }, */
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.unshift({
              'codigo': 'T',
              'id': 0,
              'valor': 'Todas'
            });
          },
          error => {
            this.StepError(error);
          }
        );
      },
      descargar(row) {
        //console.log(row)
        var url = [this.$http.options.root + 'getDeclaracion/pdf/' + row.id + '/' + this.getKey('uid')];
        window.open(url, '_blank');
      },

    },
    created() {
      this.getDependencias();
      this.getTipoDeclaracion();
      // this.getPeriodos();
      this.rol = this.getKey('role');
      this.checkPermissions()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/RepDeclaraciones2.vue